<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g id="Page-1" serif:id="Page 1" transform="matrix(0.5,0,0,0.5,0,0)">
      <rect x="0" y="0" width="2160" height="3840" style="fill: none" />
      <clipPath id="_clip1">
        <rect x="0" y="0" width="2160" height="3840" />
      </clipPath>
      <g clip-path="url(#_clip1)">
        <g id="Layer-1" serif:id="Layer 1"></g>
        <g id="Layer-2" serif:id="Layer 2" transform="matrix(2,0,0,2,0,0)">
          <image
            id="background.jpg"
            href="../assets/background.jpg"
            x="0"
            y="0"
            width="1080px"
            height="1920px"
          />
          <g
            id="Layer-11"
            serif:id="Layer 1"
            transform="matrix(0.5,0,0,0.5,0,0)"
          >
            <g transform="matrix(0,-1,-1,0,1072,746.092)" style="display: none">
              <path
                d="M-500.082,-500.082C-223.895,-500.082 -0.001,-276.188 -0.001,-0.001C-0.001,276.188 -223.895,500.082 -500.082,500.082C-776.269,500.082 -1000.16,276.188 -1000.16,-0.001C-1000.16,-276.188 -776.269,-500.082 -500.082,-500.082"
                style="fill: white; fill-rule: nonzero"
              />
            </g>
            <g id="qrcode_container" :transform="qrcodeContainerTransform">
              <path
                :d="qrcodeContainerPath"
                style="
                  fill: white;
                  fill-rule: nonzero;
                  filter: url(#dropShadow);
                "
              />
              <text
                :x="qrcodeTextX"
                :y="qrcodeTextY"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 125px;
                  fill: rgb(48, 48, 48);
                "
              >
                <tspan :x="qrcodeTextX - 20" :y="qrcodeTextY">Scan de</tspan>
                <tspan :x="qrcodeTextX - 20" dy="1.2em">QR-code</tspan>
                <tspan :x="qrcodeTextX - 20" dy="1.2em">en kom</tspan>
                <tspan :x="qrcodeTextX - 20" dy="1.2em">erachter...</tspan>
              </text>
              <rect
                :x="qrCodeRectX"
                :y="qrCodeRectY"
                width="600"
                height="600"
                rx="50"
                ry="50"
                style="
                  fill: white;
                  fill-rule: nonzero;
                  stroke: rgb(40, 110, 182);
                  stroke-width: 18px;
                  filter: url(#dropShadow);
                "
              />
              <image
                href="../assets/qr-code.png"
                :x="qrCodeImageX"
                :y="qrCodeImageY"
                width="550"
                height="550"
                preserveAspectRatio="xMidYMid meet"
                style="mix-blend-mode: multiply"
              />
            </g>
            <g
              transform="matrix(3.86567,0,0,3.86567,198.238,-717.391)"
              style="display: none"
            >
              <path
                d="M154.375,436.293L154.375,476.42L194.502,476.42L194.502,436.293L154.375,436.293ZM205.967,436.293L205.967,442.025L217.433,442.025L217.433,447.758L205.967,447.758L205.967,453.49L211.7,453.49L211.7,464.955L205.967,464.955L205.967,453.49L200.235,453.49L200.235,464.955L205.967,464.955L205.967,470.688L211.7,470.688L211.7,476.42L217.433,476.42L217.433,459.223L223.165,459.223L223.165,476.42L228.898,476.42L228.898,459.223L234.63,459.223L234.63,464.955L240.363,464.955L240.363,459.223L234.63,459.223L234.63,453.49L223.165,453.49L223.165,447.758L240.363,447.758L240.363,453.49L251.828,453.49L251.828,447.758L240.363,447.758L240.363,436.293L234.63,436.293L234.63,442.025L223.165,442.025L223.165,436.293L205.967,436.293ZM246.095,436.293L246.095,442.025L251.828,442.025L251.828,436.293L246.095,436.293ZM257.56,436.293L257.56,476.42L297.688,476.42L297.688,436.293L257.56,436.293ZM188.77,442.025L188.77,470.688L160.107,470.688L160.107,442.025L188.77,442.025ZM291.955,442.025L291.955,470.688L263.293,470.688L263.293,442.025L291.955,442.025ZM165.84,447.758L165.84,464.955L183.037,464.955L183.037,447.758L165.84,447.758ZM269.025,447.758L269.025,464.955L286.223,464.955L286.223,447.758L269.025,447.758ZM200.235,470.688L200.235,476.42L205.967,476.42L205.967,487.885L211.7,487.885L211.7,493.618L223.165,493.618L223.165,499.35L228.898,499.35L228.898,493.618L223.165,493.618L223.165,487.885L240.363,487.885L240.363,493.618L234.63,493.618L234.63,505.083L240.363,505.083L240.363,522.28L251.828,522.28L251.828,528.013L223.165,528.013L223.165,522.28L217.433,522.28L217.433,539.478L205.967,539.478L205.967,533.746L211.7,533.746L211.7,516.548L205.967,516.548L205.967,528.013L200.235,528.013L200.235,522.28L194.502,522.28L194.502,516.548L188.77,516.548L188.77,510.815L200.235,510.815L200.235,505.083L205.967,505.083L205.967,510.815L211.7,510.815L211.7,516.548L223.165,516.548L223.165,522.28L228.898,522.28L228.898,516.548L223.165,516.548L223.165,510.815L217.433,510.815L217.433,505.083L223.165,505.083L223.165,510.815L228.898,510.815L228.898,505.083L223.165,505.083L223.165,499.35L211.7,499.35L211.7,493.618L205.967,493.618L205.967,499.35L211.7,499.35L211.7,505.083L205.967,505.083L205.967,499.35L194.502,499.35L194.502,493.618L183.037,493.618L183.037,487.885L171.572,487.885L171.572,493.618L177.305,493.618L177.305,499.35L183.037,499.35L183.037,510.815L177.305,510.815L177.305,505.083L171.572,505.083L171.572,510.815L177.305,510.815L177.305,516.548L188.77,516.548L188.77,522.28L194.502,522.28L194.502,528.013L188.77,528.013L188.77,522.28L177.305,522.28L177.305,516.548L171.572,516.548L171.572,510.815L160.107,510.815L160.107,505.083L154.375,505.083L154.375,533.746L160.107,533.746L160.107,516.548L171.572,516.548L171.572,522.28L177.305,522.28L177.305,528.013L188.77,528.013L188.77,533.746L200.235,533.746L200.235,550.943L205.967,550.943L205.967,556.676L211.7,556.676L211.7,562.408L205.967,562.408L205.967,568.141L211.7,568.141L211.7,573.873L217.433,573.873L217.433,579.606L228.898,579.606L228.898,573.873L217.433,573.873L217.433,562.408L223.165,562.408L223.165,556.676L217.433,556.676L217.433,550.943L211.7,550.943L211.7,545.211L217.433,545.211L217.433,550.943L228.898,550.943L228.898,556.676L240.363,556.676L240.363,562.408L263.293,562.408L263.293,556.676L274.758,556.676L274.758,528.013L269.025,528.013L269.025,522.28L274.758,522.28L274.758,528.013L280.49,528.013L280.49,533.746L286.223,533.746L286.223,522.28L280.49,522.28L280.49,516.548L269.025,516.548L269.025,510.815L263.293,510.815L263.293,505.083L257.56,505.083L257.56,510.815L263.293,510.815L263.293,528.013L257.56,528.013L257.56,516.548L251.828,516.548L251.828,505.083L246.095,505.083L246.095,499.35L251.828,499.35L251.828,493.618L257.56,493.618L257.56,499.35L263.293,499.35L263.293,493.618L257.56,493.618L257.56,487.885L251.828,487.885L251.828,482.153L246.095,482.153L246.095,476.42L240.363,476.42L240.363,470.688L234.63,470.688L234.63,482.153L211.7,482.153L211.7,476.42L205.967,476.42L205.967,470.688L200.235,470.688ZM246.095,470.688L246.095,476.42L251.828,476.42L251.828,470.688L246.095,470.688ZM154.375,482.153L154.375,493.618L160.107,493.618L160.107,499.35L171.572,499.35L171.572,493.618L165.84,493.618L165.84,482.153L154.375,482.153ZM183.037,482.153L183.037,487.885L194.502,487.885L194.502,493.618L200.235,493.618L200.235,482.153L183.037,482.153ZM269.025,482.153L269.025,487.885L263.293,487.885L263.293,493.618L274.758,493.618L274.758,505.083L280.49,505.083L280.49,493.618L286.223,493.618L286.223,499.35L291.955,499.35L291.955,510.815L297.688,510.815L297.688,493.618L291.955,493.618L291.955,487.885L280.49,487.885L280.49,482.153L269.025,482.153ZM188.77,505.083L188.77,499.35L194.502,499.35L194.502,505.083L188.77,505.083ZM286.223,510.815L286.223,522.28L291.955,522.28L291.955,528.013L297.688,528.013L297.688,516.548L291.955,516.548L291.955,510.815L286.223,510.815ZM165.84,522.28L165.84,533.746L171.572,533.746L171.572,522.28L165.84,522.28ZM246.095,533.746L246.095,545.211L240.363,545.211L240.363,550.943L228.898,550.943L228.898,545.211L223.165,545.211L223.165,539.478L234.63,539.478L234.63,533.746L246.095,533.746ZM269.025,533.746L269.025,550.943L251.828,550.943L251.828,533.746L269.025,533.746ZM154.375,539.478L154.375,579.606L194.502,579.606L194.502,539.478L154.375,539.478ZM257.56,539.478L257.56,545.211L263.293,545.211L263.293,539.478L257.56,539.478ZM291.955,539.478L291.955,550.943L297.688,550.943L297.688,539.478L291.955,539.478ZM188.77,545.211L188.77,573.873L160.107,573.873L160.107,545.211L188.77,545.211ZM165.84,550.943L165.84,568.141L183.037,568.141L183.037,550.943L165.84,550.943ZM280.49,550.943L280.49,556.676L286.223,556.676L286.223,562.408L291.955,562.408L291.955,579.606L297.688,579.606L297.688,556.676L291.955,556.676L291.955,550.943L280.49,550.943ZM234.63,562.408L234.63,568.141L240.363,568.141L240.363,562.408L234.63,562.408ZM274.758,562.408L274.758,568.141L286.223,568.141L286.223,562.408L274.758,562.408ZM200.235,568.141L200.235,579.606L211.7,579.606L211.7,573.873L205.967,573.873L205.967,568.141L200.235,568.141ZM246.095,568.141L246.095,579.606L251.828,579.606L251.828,573.873L257.56,573.873L257.56,568.141L246.095,568.141ZM263.293,568.141L263.293,573.873L274.758,573.873L274.758,579.606L280.49,579.606L280.49,573.873L274.758,573.873L274.758,568.141L263.293,568.141Z"
                style="fill: rgb(123, 200, 0)"
              />
            </g>
          </g>
          <g
            id="leaderboard_container"
            :transform="`matrix(1,0,0,1,${leaderboardX},${leaderboardY})`"
          >
            <g
              id="Layer-21"
              serif:id="Layer 2"
              transform="matrix(0.5,0,0,0.5,0,0)"
            >
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g opacity="1">
                  <g transform="matrix(1,0,0,1,1969.27,2366.3)">
                    <rect
                      x="-1798.27"
                      y="0"
                      width="1815.002"
                      height="258.817"
                      rx="50"
                      ry="50"
                      style="
                        fill: white;
                        fill-rule: nonzero;
                        filter: url(#dropShadow);
                      "
                    />
                  </g>
                </g>
              </g>
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g opacity="1">
                  <g transform="matrix(1,0,0,1,1969.27,2686.21)">
                    <rect
                      x="-1798.27"
                      y="0"
                      width="1815.002"
                      height="258.817"
                      rx="50"
                      ry="50"
                      style="
                        fill: white;
                        fill-rule: nonzero;
                        filter: url(#dropShadow);
                      "
                    />
                  </g>
                </g>
              </g>
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g opacity="1">
                  <g transform="matrix(1,0,0,1,1969.27,2992.9)">
                    <rect
                      x="-1798.27"
                      y="0"
                      width="1815.002"
                      height="258.817"
                      rx="50"
                      ry="50"
                      style="
                        fill: white;
                        fill-rule: nonzero;
                        filter: url(#dropShadow);
                      "
                    />
                  </g>
                </g>
              </g>
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g transform="matrix(1,0,0,1,200,2545.95)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    <!-- 1 -->
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,437.681,2548.05)">
                  <g transform="matrix(129.135,0,0,129.135,342.079,0)"></g>
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[0]?.name || "" }}
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,200,2864.09)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    <!-- 2 -->
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,437.678,2866.19)">
                  <g transform="matrix(129.135,0,0,129.135,342.079,0)"></g>
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[1]?.name || "" }}
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,200,3169.57)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    <!-- 3 -->
                  </text>
                </g>
              </g>
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g transform="matrix(1,0,0,1,285.803,2545.95)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      font-weight: 500;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    1
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,285.801,2864.09)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      font-weight: 500;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    2
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,285.803,3169.57)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 143.631px;
                      font-weight: 500;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    3
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,437.681,3166.67)">
                  <g transform="matrix(129.135,0,0,129.135,342.079,0)"></g>
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[2]?.name || "" }}
                  </text>
                </g>
              </g>
              <g transform="matrix(1,0,0,1,0,170.478)">
                <g transform="matrix(1,0,0,1,1648.58,2548.11)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-weight: 700;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[0]?.score ?? "" }}
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,1644.7,2866.29)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-weight: 700;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[1]?.score ?? "" }}
                  </text>
                </g>
                <g transform="matrix(1,0,0,1,1655.55,3166.79)">
                  <text
                    x="0px"
                    y="0px"
                    style="
                      font-family: 'Inter', 'Open Sans', sans-serif;
                      font-weight: 700;
                      font-size: 129.135px;
                      fill: rgb(48, 48, 48);
                    "
                  >
                    {{ getHiScore[2]?.score ?? "" }}
                  </text>
                </g>
              </g>
            </g>
          </g>
          <g class="swing">
            <g :transform="`matrix(1,0,0,1,${headlineX},${headlineY})`">
              <text
                x="0px"
                y="0px"
                text-anchor="middle"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 800;
                  font-size: 120px;
                  fill: rgb(254, 254, 254);
                "
              >
                <tspan x="0px" y="0px">Hoe snel is</tspan>
                <tspan x="0px" dy="1.2em">jouw reactie?</tspan>
              </text>
            </g>
          </g>
          <g
            id="promoTextContainer"
            :transform="`matrix(1,0,0,1,${promoTextX},${promoTextY})`"
          >
            <text
              x="0"
              y="0"
              text-anchor="middle"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 800;
                font-size: 60;
                fill: rgb(254, 254, 254);
              "
            >
              <tspan x="0" y="0">Speel en win!</tspan>
            </text>
            <text
              x="0"
              y="0"
              text-anchor="middle"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 500;
                font-size: 50;
                fill: rgb(254, 254, 254);
              "
            >
              <tspan x="0" dy="1.54em">1. Lunch t.w.v. €200,-</tspan>
              <tspan x="0" dy="1.5em">
                2. Team SD Worx - Protime wielerkleding
              </tspan>
              <!-- Removed this line as it is now included in the previous line -->
              <tspan x="0" dy="1.5em">3. Boek: Join the Club</tspan>
            </text>
          </g>
          <g id="CodeBtn" @click="enterCodeScreen()">
            <g :transform="`matrix(0.5,0,0,0.5,${codeBtnX},${codeBtnY})`">
              <rect
                x="-1798.27"
                y="0"
                width="1815.002"
                height="258.817"
                rx="50"
                ry="50"
                style="
                  fill: rgba(145, 202, 238, 1);
                  fill-rule: nonzero;
                  filter: url(#dropShadow);
                "
              />
            </g>
            <g
              :transform="`matrix(0.5,0,0,0.5,${codeBtnTextOffsetX},${codeBtnTextOffsetY})`"
            >
              <text
                :x="codeBtnTextX"
                :y="codeBtnTextY"
                text-anchor="middle"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 800;
                  font-size: 120px;
                  fill: rgb(22, 38, 78);
                "
              >
                Vul jouw code in
              </text>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter id="dropShadow">
        <feOffset dx="0" dy="30" result="offsetblur" />
        <feGaussianBlur in="offsetblur" stdDeviation="6" result="outputblur" />
        <feFlood flood-color="rgba(0,0,0,0.2)" result="offsetblur" />
        <feComposite
          in="offsetblur"
          in2="outputblur"
          operator="in"
          result="offsetblur"
        />
        <feMerge>
          <feMergeNode in="offsetblur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "InactiveScreen",
  components: {},
  data() {
    return {
      qrcodeContainerAngle: 0,
      qrcodeCornerRadius: 200,
      qrcodeX: 164.499,
      qrcodeY: 800,
      qrcodeWidth: 1815.002,
      qrcodeHeight: 800,
      qrcodeTextX: 380,
      qrcodeTextY: 1020,
      qrCodeRectX: 1100,
      qrCodeRectY: 900,
      qrCodeImageX: 1125,
      qrCodeImageY: 925,
      headlineX: 580,
      headlineY: 150,
      headlineFontSize: 10,
      leaderboardX: 0,
      leaderboardY: 150,
      promoTextX: 540,
      promoTextY: 915,
      promoTextFontSize: 50,
      promoTextLineHeight: 1.5,
      promoTextColor: "rgb(254, 254, 254)",
      promoTextWeight: 700,
      codeBtnX: 984.635,
      codeBtnY: 1230,
      codeBtnTextX: 1090,
      codeBtnTextY: 3070,
      codeBtnTextOffsetX: -8.5793,
      codeBtnTextOffsetY: -220.508,
    };
  },
  created() {
    this.$store.dispatch("getHiScore");
  },
  computed: {
    getHiScore() {
      const hiScore = this.$store.getters.getHiScore;
      return Array.isArray(hiScore) ? hiScore : [];
    },
    loading() {
      return this.$store.getters.getLoading;
    },
    qrcodeContainerTransform() {
      return `rotate(${this.qrcodeContainerAngle} 1072 1046.0915)`;
    },
    qrcodeContainerPath() {
      const x = this.qrcodeX;
      const y = this.qrcodeY;
      const width = this.qrcodeWidth;
      const height = this.qrcodeHeight;
      const maxRadius = Math.min(width, height);
      const radius = Math.max(0, Math.min(this.qrcodeCornerRadius, maxRadius));
      const right = x + width;
      const bottom = y + height;
      return [
        `M${x},${y}`,
        `L${right},${y}`,
        `L${right},${bottom - radius}`,
        `C${right},${bottom - radius + radius * 0.523} ${
          right - radius + radius * 0.5523
        },${bottom} ${right - radius},${bottom}`,
        `L${x},${bottom}`,
        `L${x},${y}Z`,
      ].join("");
    },
  },
  methods: {
    enterCodeScreen() {
      this.$store.commit("setGameState", "entercode");
    },
  },
};
</script>

<style scoped>
.notfound {
  color: #d06690;
}
</style>
